<div class="container">
    <app-navbar></app-navbar>
    <app-shared-loading *ngIf="loading"></app-shared-loading>
    <div id="ticketDiv">
        <div class="voucherBox">
            <p class="topMsg">{{ 'payment-Receipt-Title' | translation | async }}</p>
            <img src="assets/images/payvalida.svg" alt="Payvalida, pasarela de pagos"
                title="Payvalida, pasarela de pagos" class="voucherLogo" />
            <div class="retryConfirmation" *ngIf="isPending && tryLeftConsult > 0 && !loading">
                {{ 'process-Order-Info-Title' | translation | async }} <b>{{ timeIntervalToRequestAgain }}</b> {{
                'html-Seconds-Title'| translation | async }}.
            </div>

            <div class="leftInfoVoucher">
                <h1 class="approved"> {{ responseOrderStatus.title | translation | async }} </h1>
                <p *ngIf="isPending" class="transfiyaTrxInfo"> {{ responseOrderStatus.message | translation | async }}
                </p>

                <h2>{{ transaction.MERCHANT_NAME }}</h2>

                <br>

                <p>{{ 'date-title' | translation | async }} {{ currentDate }}</p>
                <p class="reference" *ngIf="transaction?.ORDER_REFERENCE != null">
                    <b>{{ 'reference-label' | translation | async }}:</b> {{ transaction?.ORDER_REFERENCE }}
                </p>
                <p *ngIf="transferId != null">
                    <b class="reference">{{ 'transfer-id-title' | translation | async }}:</b> {{ transferId }}
                </p>
                <br>
                <div class="flexBox">
                    <div class="column">
                        <b>{{ 'html-Total-Title' | translation | async }}:</b>
                    </div>
                    <div class="column">
                        <b>{{ transaction.ORDER_AMOUT | number : '1.2-2' }} {{ transaction.ORDER_CURRENCY }}</b>
                    </div>
                </div>
                <br>
            </div>
            <p class="voucherFooter">{{ 'no-Print-Receipt' | translation | async }}</p>
            <br>
            <app-buttons-bar [valid]="true" template="transfiya" nameCustom="{{ 'check-transfiya-status' | translation | async }}"
                (CUSTOM)="consultTransfiyaStatus()" *ngIf="tryLeftConsult == 0">
            </app-buttons-bar>
            <br>
            
            <app-generic-button *ngIf="isRejected" text="{{ 'html-Retry-Payment' | translation | async }}"
                (click)="retryPayment()"></app-generic-button>
            <app-buttons-bar [valid]="true" (PR)="printPaymentReceipt()"></app-buttons-bar>
        </div>
    </div>
    <div class="returnMerchantContainer" *ngIf="transaction != null && transaction?.MERCHANT_URL_RETURN != ''">
        <a class="returnMerchant" [href]="transaction?.MERCHANT_URL_RETURN"><fa-icon icon="arrow-left"
                size="lg"></fa-icon>
            {{ 'return-to' | translation | async }} {{transaction?.MERCHANT_NAME}}</a>
    </div>
</div>